import React from 'react';
import PropTypes from 'prop-types';
import TicketImageContainer from '../TicketImageContainer';
import { Box, Typography } from '@material-ui/core';
import { useDetailInformationStyles } from '../../../mis-compras/components/mobile/detail-view/styles';

const DetailInformation = ({ ...props }) => {
  const { ticket } = props;
  const classes = useDetailInformationStyles();
  return (
    <Box display="flex" justifyContent="center" className={classes.container}>
      <TicketImageContainer
        isMkp={ticket.isMkp}
        thumbnailImage={ticket.thumbnailImage}
      />
      <Box display="flex" flexDirection="column">
        <Typography className={classes.title}>
          <strong>{ticket.name}</strong>
        </Typography>
        {ticket.orderId && (
          <Typography className={classes.subtitle}>
            <span className={classes.subtitleWeight}>Nº de compra: </span>
            {ticket.orderId}
          </Typography>
        )}
        {ticket.sku && (
          <Typography className={classes.subtitle}>
            <span className={classes.subtitleWeight}>SKU: </span>
            {ticket.sku}
          </Typography>
        )}
      </Box>
    </Box>
  );
};

DetailInformation.propTypes = {
  ticket: PropTypes.object,
};

export default DetailInformation;
